/**
 * MIRA Sheet Component
 * Wraps Shadcn Sheet with MIRA design system styles
 */

import React from 'react';
import {
  Sheet as ShadcnSheet,
  SheetPortal,
  SheetOverlay,
  SheetTrigger,
  SheetClose,
  SheetContent as ShadcnSheetContent,
  SheetHeader as ShadcnSheetHeader,
  SheetFooter as ShadcnSheetFooter,
  SheetTitle as ShadcnSheetTitle,
  SheetDescription as ShadcnSheetDescription,
} from '@/components/ui/sheet';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/layout/sheet.module.css';

export const Sheet = ({ children, ...props }) => {
  return <ShadcnSheet {...props}>{children}</ShadcnSheet>;
};

export const SheetContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSheetContent
        ref={ref}
        className={cn(styles.miraSheetContent, className)}
        {...props}
      />
    );
  }
);

SheetContent.displayName = 'MiraSheetContent';

export const SheetHeader = ({ className, ...props }) => {
  return (
    <ShadcnSheetHeader
      className={cn(styles.miraSheetHeader, className)}
      {...props}
    />
  );
};

export const SheetFooter = ({ className, ...props }) => {
  return (
    <ShadcnSheetFooter
      className={cn(styles.miraSheetFooter, className)}
      {...props}
    />
  );
};

export const SheetTitle = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSheetTitle
        ref={ref}
        className={cn(styles.miraSheetTitle, className)}
        {...props}
      />
    );
  }
);

SheetTitle.displayName = 'MiraSheetTitle';

export const SheetDescription = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSheetDescription
        ref={ref}
        className={cn(styles.miraSheetDescription, className)}
        {...props}
      />
    );
  }
);

SheetDescription.displayName = 'MiraSheetDescription';

// Re-export utility components
export { SheetTrigger, SheetClose, SheetPortal, SheetOverlay };
